module.exports = __webpack_public_path__ + "static/media/cubeload.b4141e59.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/cubeload.gif
// module id = 436
// module chunks = 0